/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type {
    GetV1InternalcategoriesQueryParams,
    GetV1InternalcategoriesQueryResponse,
} from '../../types/GetV1Internalcategories.ts'

export const getV1InternalcategoriesQueryKey = (params?: GetV1InternalcategoriesQueryParams) =>
    [{ url: '/v1/InternalCategories' }, ...(params ? [params] : [])] as const

export type GetV1InternalcategoriesQueryKey = ReturnType<typeof getV1InternalcategoriesQueryKey>

/**
 * {@link /v1/InternalCategories}
 */
export async function getV1Internalcategories(
    params?: GetV1InternalcategoriesQueryParams,
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1InternalcategoriesQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/InternalCategories`, params, ...requestConfig })
    return res
}

export function getV1InternalcategoriesQueryOptions(
    params?: GetV1InternalcategoriesQueryParams,
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1InternalcategoriesQueryKey(params)
    return queryOptions<
        ResponseConfig<GetV1InternalcategoriesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1InternalcategoriesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Internalcategories(params, config)
        },
    })
}

/**
 * {@link /v1/InternalCategories}
 */
export function useGetV1Internalcategories<
    TData = ResponseConfig<GetV1InternalcategoriesQueryResponse>,
    TQueryData = ResponseConfig<GetV1InternalcategoriesQueryResponse>,
    TQueryKey extends QueryKey = GetV1InternalcategoriesQueryKey,
>(
    params?: GetV1InternalcategoriesQueryParams,
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1InternalcategoriesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1InternalcategoriesQueryKey(params)

    const query = useQuery(
        {
            ...getV1InternalcategoriesQueryOptions(params, config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
